import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function HairDryer(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M13.798 4.813C16.951 4.033 20 6.42 20 9.667v.613c0 3.262-3.073 5.65-6.234 4.846L8 13.655V6.25l5.798-1.436zM6 6.744L4 7.24v5.4l2 .509V6.744zm16 2.923c0-4.548-4.268-7.888-8.682-6.795L2.76 5.486a1 1 0 00-.76.97v6.96a1 1 0 00.753.968l10.368 2.641 1.202 3.608A2 2 0 0016.221 22H18a2 2 0 002-2v-4.82a6.948 6.948 0 002-4.9v-.613zM16.22 20l-.907-2.723a6.937 6.937 0 002.687-.67V20h-1.78zM16 10a1 1 0 11-2 0 1 1 0 012 0zm2 0a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }));
}

export default HairDryer;